import { render, staticRenderFns } from "./CodeGenerator.vue?vue&type=template&id=b9857f2c&"
import script from "./CodeGenerator.vue?vue&type=script&lang=js&"
export * from "./CodeGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports